// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "-legacy." + {"36":"9455518b","242":"8c74672d","337":"09c1733a","411":"9466aa8b","481":"6a6dc4fe","594":"eec6a72d","630":"cec28a86","700":"b2c9aed1","703":"8c5d1822","876":"beb7df4a","986":"87ef07e0"}[chunkId] + ".js";
};